import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-loading',
    template: `
    <div class="m-page-loader" [class.m-page-loader--non-block]="isLoading">
      <div class="m-blockui">
        <span>
          {{loading}}...
        </span>
        <span>
          <div class="m-loader m-loader--brand"></div>
        </span>
      </div>
    </div>
  `,
    styles: ['./loading.componet.scss']
})
export class LoadingComponent {
    @Input() loading: string = 'Cargando';
    @Input() isLoading: boolean = true;
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/loading/loading.component.ts